// src/components/strumenti/NumeroApparecchi.js — W442. Numero di apparecchi, metodo del flusso totale
import React from "react";
import { useCampi, Campo, Griglia, Risultato, Formula, Azzera, fmt } from "./UiStrumento";
import { numeroApparecchi } from "../../utils/calcoliStrumenti";

export default function NumeroApparecchi() {
  const { v, set, n, azzera } = useCampi({ lux:"", area:"", lm:"", cu:"0.6", mf:"0.8" });
  const r = numeroApparecchi(n("lux"), n("area"), n("lm"), n("cu"), n("mf"));
  return (
    <div>
      <Griglia colonne={3}>
        <Campo etichetta="Illuminamento richiesto (lux)" valore={v.lux} onChange={set("lux")} placeholder="Es. 500" aiuto="Es. uffici 500 lux (UNI EN 12464-1)."/>
        <Campo etichetta="Superficie (m²)" valore={v.area} onChange={set("area")} placeholder="Es. 100"/>
        <Campo etichetta="Flusso per apparecchio (lm)" valore={v.lm} onChange={set("lm")} placeholder="Es. 4000"/>
        <Campo etichetta="Coefficiente di utilizzazione CU" valore={v.cu} onChange={set("cu")} aiuto="0–1: dipende da locale e ottica (tipico 0,5–0,7)."/>
        <Campo etichetta="Fattore di manutenzione MF" valore={v.mf} onChange={set("mf")} aiuto="0–1: tipico 0,8 in ambienti puliti."/>
      </Griglia>
      <Risultato settore="illuminazione" titolo="Apparecchi necessari" valore={r ? String(r.n) : "—"}
        righe={r ? [["Valore esatto", fmt(r.esatto, 2)], ["Illuminamento medio ottenuto", fmt(r.luxOttenuti, 0) + " lux"]] : []}/>
      <Formula>Metodo del flusso totale: N = E × A ÷ (Φ × CU × MF), arrotondato per eccesso. Dà l'illuminamento medio, non l'uniformità né l'abbagliamento: per il progetto serve un calcolo illuminotecnico (es. DIALux).</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
